export default __webpack_public_path__ + "static/media/persons.a73317c6.svg";